import Phaser from 'phaser';

// Import all scenes
import BootScene from './scenes/BootScene';
import TitleScene from './scenes/TitleScene';
import FactionSelectScene from './scenes/FactionSelectScene';
import LoreScene from './scenes/LoreScene';
import GameScene from './scenes/GameScene';
import PauseScene from './scenes/PauseScene';
import GameOverScene from './scenes/GameOverScene';

import { GAME_CONFIG } from './data/GameConstants';

export const createGameConfig = (parent) => ({
  type: Phaser.AUTO,
  parent: parent,
  width: GAME_CONFIG.width,
  height: GAME_CONFIG.height,
  backgroundColor: '#0A0505',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 0 },
      debug: false
    }
  },
  scene: [
    BootScene,
    TitleScene,
    FactionSelectScene,
    LoreScene,
    GameScene,
    PauseScene,
    GameOverScene
  ],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },
  pixelArt: true,
  antialias: false
});

export default createGameConfig;
